<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <div :class="['nav-link', currentTab === 1 ? 'active' : '']" >
                                {{ $t('online_contract.contracts') }}
                            </div>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="#contracts">
                        <div style="margin-top: 15px" id="contracts" aria-labelledby="contracts"
                             data-parent="#contracts">
                            <contract-filter :action="filterAction"></contract-filter>
                            <kt-row v-if="contract_statistics_status === 'success'">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <normal_statistics
                                        :accountingStatistics="contract_statistics.pending_count"
                                        :title="$t('reports.online_contracts.pending_count')"
                                    />
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <normal_statistics
                                        :accountingStatistics="contract_statistics.signed_count"
                                        :title="$t('reports.online_contracts.signed_count')"
                                    />
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <normal_statistics
                                        :accountingStatistics="contract_statistics.end_count"
                                        :title="$t('reports.online_contracts.end_count')"
                                    />
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <statistics
                                        :accountingStatistics="contract_statistics.sum_price"
                                        :title="$t('reports.online_contracts.sum_price')"
                                    />
                                </div>
                            </kt-row>
                            <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
                        </div>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import columns from './datatable/ContractColumns'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import contractFilter from './components/contract/contract-filter.vue'
import mainContent from '@/components/main-content'
import Normal_statistics from "@/views/reports/components/normal-statistics.vue";
import {mapGetters} from "vuex";
import Statistics from "@/views/reports/components/accounting-statistics.vue";
import contractActions from "@/views/user/datatable/ContractActions.vue";


export default {

    components: {
        Statistics,
        Normal_statistics,
        contractFilter,
        mainContent
    },
    data() {
        return {
            query: {},
            currentTab: 1
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "deposit_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('online-contract/contract'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: contractActions
            }
        },
        ...mapGetters('onlineContract',[
                'contract_statistics_status',
                'contract_statistics'
            ]
        ),
    },

    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
            this.$store.dispatch('onlineContract/getContractStatistics', this.query)
        },
        gotoTab(index) {
            this.currentTab = index;
        }
    },
    mounted() {
        this.$store.dispatch('onlineContract/getContractStatistics', this.query)
    }
}
</script>

<style>

</style>